import React, { useState } from "react";
import axios from "axios";
import { FaMobileAlt, FaRegUser } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearServiceType } from "../../reduxSlices/serviceSlice";
import "./nomVerification.css";
import OtpPage from "../OTPPage/OtpPage";

function formatMobileNumber(mobileNom) {
  // Remove all non-digit characters
  let cleaned = mobileNom.replace(/\D/g, "");

  // If number starts with 966, remove it
  if (cleaned.startsWith("966")) {
    cleaned = cleaned.substring(3);
  }

  // If number starts with 0, remove it
  if (cleaned.startsWith("0")) {
    cleaned = cleaned.substring(1);
  }

  // If number starts with 00966, remove it
  if (cleaned.startsWith("00966")) {
    cleaned = cleaned.substring(5);
  }

  return cleaned;
}

const isValidMobileNumber = (mobileNom) => {
  mobileNom = mobileNom.trim();
  if (mobileNom === "") {
    return false;
  }

  // Remove any non-digit characters for validation
  const cleanedNumber = mobileNom.replace(/\D/g, "");

  // Check if it's a valid Saudi mobile number (9 digits without country code)
  const ksaMobileRegex = /^5[0-9]{8}$/;
  return ksaMobileRegex.test(cleanedNumber);
};

const VerifiyMobileNumber = () => {
  const [mobileNom, setMobilNom] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const { serviceType } = useSelector((state) => state.service);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleVerificationSuccess = () => {
    // Route based on service type
    if (serviceType === "clean") {
      navigate("/cleanServAppointment");
    } else {
      navigate("/appointment");
    }

    // Clear the service type after use
    dispatch(clearServiceType());
  };

  const submit = async (e) => {
    e.preventDefault();
    const mobileNomIsValid = isValidMobileNumber(mobileNom);

    if (!mobileNomIsValid) {
      setErrorMessage("برجاء ادخال رقم هاتف صحيح (مثال: 512345678)");
      return;
    }

    setErrorMessage("");

    // Format the mobile number correctly
    const formattedPhoneNumber = formatMobileNumber(mobileNom);
    localStorage.setItem("mobileNumber", formattedPhoneNumber);

    try {
      const response = await axios.post(
        `https://api.generalhome.sa/api/SMS/SendOTP?phoneNumber=${formattedPhoneNumber}`,
        { phoneNumber: formattedPhoneNumber }
      );

      if (response.status === 200) {
        const id = response.data.id;
        localStorage.setItem("verificationId", id);
        setShowOtpPopup(true);
      } else {
        setErrorMessage("حدث خطأ أثناء التحقق من رقم هاتفك.");
      }
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message ||
          "حدث خطأ في الاتصال بالشبكة. يرجى المحاولة مرة أخرى لاحقًا."
      );
    }
  };

  return (
    <section className="nomVerification">
      <div className="nomVerification-container container">
        <div className="intro-box">
          <h5>
            <FaRegUser /> تسجيل دخول
          </h5>
          <p>
            للحجز أضف رقم جوالك أدناه ، وسيتم ارسال رساله نصيه للتحقق من رقم
            الجوال المضاف ..
          </p>
        </div>
        <form onSubmit={submit}>
          <div className="inputBox">
            <input
              type="text"
              placeholder="5xxxxxxxx"
              onChange={(e) => setMobilNom(e.target.value)}
              value={mobileNom}
              dir="ltr"
              maxLength="9"
            />
            <input
              className="text-center"
              type="text"
              value={"966+"}
              readOnly
            />
          </div>
          {errorMessage && <p className="text-danger">{errorMessage}</p>}
          <button type="submit">
            <FaMobileAlt />
            ارسال رمز التحقق
          </button>
        </form>
        {showOtpPopup && (
          <OtpPage
            onClose={() => setShowOtpPopup(false)}
            onVerificationSuccess={handleVerificationSuccess}
          />
        )}
      </div>
    </section>
  );
};

export default VerifiyMobileNumber;
